import * as React from 'react';

function CrossSymetric(props) {
    return (
        <svg viewBox="0 0 32 32" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M29.828 0L16 13.828L2.172 0L0 2.173L13.829 16L0 29.829L2.172 32L16 18.172L29.828 32L32.001 29.829L18.172 16L32.001 2.173L29.828 0Z"
            />
        </svg>
    );
}

export default CrossSymetric;
